import { isString } from 'class-validator';
import { activePhoneRegex, fullNameRegex, phoneRegex } from '@hilma/netina2all';

import { createRules } from '../../functions';

export const driverRules = createRules({
	driverName: { regex: fullNameRegex, name: i18n => i18n.am.dInfo.dName, greaterThan: 2, smallerThan: 45, required: true },
	phone: { name: i18n => i18n.am.dInfo.phone, regex: phoneRegex, activeRegex: activePhoneRegex, activeRegexErr: i18n => i18n.errText.numbersOnly, required: true, length: 10 },
	notes: { greaterThan: 2, smallerThan: 1000, name: i18n => i18n.am.dInfo.notes, classValidator: (value: string) => isString(value), required: false },
	carModel: { required: true },
	carModelOther: { required: false, greaterThan: 2, smallerThan: 50 },
	hourRange: { required: true, dateType: 'timeRange' }
});